<template>
  <a-collapse-panel
    :collapsible="disabled || undefined"
    v-bind="attrs"
    :class="bem.b()"
  >
    <template
      v-for="item in Object.keys($slots).filter(
        (slot) => slot !== 'extra' && slot !== 'header'
      )"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template #header>
      <slot v-if="$slots.header" name="header" />
      <template v-else>
        <ll-icon
          v-if="headerIcon.iconName"
          v-bind="headerIcon"
          :style="{
            marginRight: iconSpace + 'px',
          }"
        />
        {{ header }}
      </template>
    </template>

    <template #extra>
      <slot name="extra" />
    </template>
  </a-collapse-panel>
</template>

<script lang="ts" setup>
import { useAttrs } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { collapsePanelProps } from './collapse'

defineOptions({ name: 'LlCollapsePanel' })
const bem = createNamespace('collapse-panel')

const attrs = useAttrs()

defineProps(collapsePanelProps)
</script>
